import React, {Suspense, useContext, useEffect, useState} from 'react';
import {useSelector, useStore} from 'react-redux';

import Checkers from '../../../../../helpers/class/Checkers';

import DetailDescViewPort from './left/DetailDescViewPort';
import FeaturedImagesViewPort from './left/FeaturedImagesViewPort';
import FeaturesViewPort from './left/FeaturesViewPort';
import ServicesViewPort from './left/ServicesViewPort';
import SpacesViewPort from './left/SpacesViewPort';
import ThemesViewPort from './left/ThemesViewPort';
import {useIsSSR} from "@react-aria/ssr";
import TermsViewPort from "./left/TermsViewPort";
import PropertyHeading from "./left/PropertyHeadingDescViewPort";
import {fetchBuilderSettingByKey} from "../../../../../helpers/MethodHelper";
import ModalPois from "../../partials/modals/ModalPois";
import ArticleCategoriesContainer from "../../../articles/ArticleCategoriesContainer";
import {ExperiencesDestination} from "./left/ExperiencesDestination";
import {RelatedProperties} from "./left/RelatedProperties";
import Highlights from "./right/HighlightsViewPort";
import Skeleton from "react-loading-skeleton";
import {MediaSection} from "./left/MediaSection";
import BedroomDetails from './left/BedroomsView';
import SinglePropertyData from './left/ChainPropertyData';
import BedroomsView from "./left/BedroomsView";
import SinglePropertyContactForm from '../../../../contact/SinglePropertyContactForm';
import ChainPropertyData from './left/ChainPropertyData';

export default function LeftSide ( props ) {
    const isServer = useIsSSR();

    const isPublicDomain = useSelector(state => state['appSettings']['isPublicDomain'])

    const isBookingsActive = useSelector(state => (state['appSettings']['isBookingsActive']==1 && fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_activate')==1) ? 1 : 0);

    const isHotel = useSelector(state => state['appSettings']['isHotel'])

    const isChain = useSelector(state => Checkers.valueToBoolean(state['appSettings']['isChain']))

    const factsheetDocument = props.details.hasOwnProperty('factsheet_document') ? props.details.factsheet_document : null

    const threesixtyTour = props.details.hasOwnProperty('threesixty_tour') ? props.details.threesixty_tour : null

    const experiences = props.details.experiences

    let show_themes = true;

    if (props.builder != null && Checkers.objChildExists(props.builder, 'builder_property_page_cat_show')) {
        show_themes = Checkers.valueToBoolean(props.builder.builder_property_page_cat_show);
    }

    const spaces_obj = {
        areaSqm: props.details.property_area_sqm,
        areaOutdoorSqm: props.details.property_area_outdoor_sqm,
        spaces: props.spaces,
    }

    const [mainClass, setMainClass] = useState('col-12 col-lg-8 p-t-20');

    const bookingBoxPosition = props.app.builder.builder_singleproperty_booking_box_position


    const singlePropertyData = useSelector(state => state['singlePropertyData']['propertyData'])

    const chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null

    const [chain, setChain] = useState(chainId)

    useEffect(() => {
        setChain(chainId)

    }, [chainId])


    const handleMainClass = () => {
        if (isPublicDomain == 1 || isBookingsActive == 0 || isHotel || isChain) {
            setMainClass('col-12 col-lg-12 p-t-20')
        }
        if (bookingBoxPosition == 'FIXED') {
            setMainClass('offset-1 col-10 col-lg-10 p-t-20')
        }
        // if(chain) {
        //     setMainClass('col-12 col-lg-12 p-t-20')
        // }
    }

    useEffect(() => {
        handleMainClass()
    }, [isBookingsActive, isPublicDomain, bookingBoxPosition, singlePropertyData])

    const titlePositionBeforeJumbotron = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_title_position')
    );

    const moveRelatedPropertiesBelowMap = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_move_below_map'))
    );

    const areasLayoutSetting = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_layout'));

    return (
        <div className={!chainId ? mainClass : 'col-12 col-lg-12 p-t-20'}>
            {
                props.app.propertySections.length == 0 ?
                    <>
                        {
                            titlePositionBeforeJumbotron != 1 ?
                                <PropertyHeading
                                    details={props.details}
                                    location={props.location}
                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                    isChain={isChain}
                                />
                                :
                                <></>
                        }
                       {
                           !isChain ?
                           <DetailDescViewPort details={props.details}
                                               location={props.location}
                                               readMore={props.details.desc_brief != null || props.details.desc_details != null}
                           /> : <></>
                       }
                        {/*<HighlightsViewPort highlights={props.highlights}/>*/}
                        {
                            show_themes && !isChain ?
                            <ThemesViewPort
                                themes={props.themes}
                            /> : <></>
                        }
                        {
                            !isChain ?
                                <FeaturedImagesViewPort images={props.images}
                                                        images_count={props.images_count}
                                                        all_images={props.all_images}
                                />
                                :
                                <></>
                        }
                        {
                            !isChain ?
                                <MediaSection factsheetDocument={factsheetDocument}
                                                  threesixtyTour={threesixtyTour}
                                />
                                :
                                <></>
                        }
                        {
                            Checkers.displaySpaces(spaces_obj, areasLayoutSetting) && !isChain ? 
                            <SpacesViewPort
                                areaSqm={spaces_obj.areaSqm}
                                areaOutdoorSqm={spaces_obj.areaOutdoorSqm}
                                spaces={spaces_obj.spaces}
                                isHotel={props.isHotel}
                            /> : <></>
                        }
                        {!isChain ?
                            <FeaturesViewPort app={props.app}
                                              features={props.features}
                            />
                            :
                            <></>
                        }
                        {
                            !isChain ?
                                <ServicesViewPort services={props.services}
                                                  page_title={props.page_title}
                                />
                                :
                                <></>
                        }
                        {/*{*/}
                        {/*    <>*/}
                        {/*        <div id="pro_distances_section" className="pb-5">*/}
                        {/*            <h2 className="m-t-5">Distances & directions</h2>*/}
                        {/*            <ModalPois descAreaDistances={Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances} map_pois={props.map_pois} />*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}
                        {
                            props.terms != undefined && props.terms.length > 0 ?
                                <TermsViewPort terms={props.terms} descRules={props.details.desc_rules}/>
                                :
                                <></>
                        }

                        {!isChain ? <ExperiencesDestination experiences={experiences} app_data={props.app_data} app={props.app}
                                                builder={props.builder}/> : <></>}

                        {/*<BedroomHotel />*/}

                        {
                            !moveRelatedPropertiesBelowMap && !isChain ?
                                <>
                                    <RelatedProperties propertyId={props.property_id} app_data={props.app_data}
                                        app={props.app} builder={props.builder} isHotel={false} isChain={false} />
                                </>
                                :
                                <></>
                        }
                        {
                            !moveRelatedPropertiesBelowMap ?
                                <>
                                    {isHotel ? <BedroomsView isHotel={true} /> : <></>}
                                </>
                                :
                                <></>
                        }
                        {
                            !moveRelatedPropertiesBelowMap ?
                                <>
                                    {
                                        isChain ?
                                            <ChainPropertyData isChain={isChain}/>
                                            :
                                            <></>
                                    }
                                </>
                                :
                                <></>
                        }
                        {/* {
                            !moveRelatedPropertiesBelowMap ?
                                <>
                                    <>{!isChain ? <SinglePropertyContactForm/> : <></>}</>
                                </>
                                :
                                <></>
                        } */}

                    </>  
                    :
                    <>
                        {
                            titlePositionBeforeJumbotron != 1 ?
                                <PropertyHeading
                                    details={props.details}
                                    location={props.location}
                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                    isChain={isChain}
                                />
                                :
                                <></>
                        }
                        {
                            props.app.propertySections.map((section) => {

                                if (!section.isActive) {
                                    return (
                                        <></>
                                    )
                                }

                                switch (section.type) {
                                    case 'SYSTEM_PROPERTY_THEMES': {
                                        return (
                                            show_themes && !isChain ?
                                            <ThemesViewPort
                                                themes={props.themes}
                                            /> : <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_DESCRIPTION': {
                                        return (
                                            <>
                                                <DetailDescViewPort
                                                    details={props.details}
                                                    location={props.location}
                                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                                />
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_GALLERY': {
                                        return (
                                            <>
                                            {!isChain ? <FeaturedImagesViewPort
                                                images={props.images}
                                                images_count={props.images_count}
                                                all_images={props.all_images}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_MEDIA': {
                                        return (
                                            <>
                                            {!isChain ? <MediaSection factsheetDocument={factsheetDocument}
                                                          threesixtyTour={threesixtyTour}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_HIGHLIGHTS': {
                                        return (
                                            <>
                                            {!isChain ?<Highlights highlights={props.highlights}/> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_SPACES': {
                                        return (
                                            <>
                                            {!isChain ? Checkers.displaySpaces(spaces_obj, areasLayoutSetting) &&
                                            <SpacesViewPort
                                                areaSqm={spaces_obj.areaSqm}
                                                areaOutdoorSqm={spaces_obj.areaOutdoorSqm}
                                                spaces={spaces_obj.spaces}
                                                isHotel={props.isHotel}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_AMENITIES': {
                                        return (
                                            <>
                                           {!isChain ? <FeaturesViewPort
                                                app={props.app}
                                                features={props.features}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_SERVICES': {
                                        return (
                                            <>
                                            {!isChain ? <ServicesViewPort
                                                services={props.services}
                                                page_title={props.page_title}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_TERMS': {
                                        return (
                                            <>
                                            {!isChain ? <TermsViewPort terms={props.terms} descRules={props.details.desc_rules}/> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_DISTANCES': {
                                        return (
                                            <>
                                                {
                                                    (Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances) || Checkers.isValidArray(props.map_pois) ?
                                                        <>
                                                            <div id="pro_distances_section" className="pb-5">
                                                                <h2 className="m-t-5">Distances & directions</h2>
                                                                <ModalPois
                                                                    descAreaDistances={Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances}
                                                                    map_pois={props.map_pois}/>
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                }
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_EXPERIENCES': {
                                        return (
                                            <>
                                                <ExperiencesDestination experiences={experiences}
                                                                        app_data={props.app_data} app={props.app}
                                                                        builder={props.builder}/>
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_RELATED_PROPERTIES': {
                                        return (
                                            !moveRelatedPropertiesBelowMap && !isChain?
                                                <>
                                                    <RelatedProperties propertyId={props.property_id}
                                                                       app_data={props.app_data} app={props.app}
                                                                       builder={props.builder} isHotel={false} isChain={false}/>
                                                </>
                                                :
                                                <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_ROOM_TYPES': {
                                        return (
                                            !moveRelatedPropertiesBelowMap ?
                                                <>
                                                    {isHotel ? <BedroomsView isHotel={true} /> : <></>}
                                                </>
                                                :
                                                <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_CHAIN_PROPERTIES': {
                                        return (
                                            !moveRelatedPropertiesBelowMap ?
                                                <>{isChain ? <ChainPropertyData isChain={isChain}/> : <></>}</>
                                                :
                                                <></>
                                        )
                                    }
                                    // case 'SYSTEM_PROPERTY_CONTACT_FORM': {
                                    //     return (
                                    //         !moveRelatedPropertiesBelowMap ?
                                    //             <>{!isChain ? <SinglePropertyContactForm /> : <></>}</>
                                    //             :
                                    //             <></>
                                    //     )
                                    // }
                                    default: {
                                        return (
                                            <></>
                                        )
                                    }
                                }
                            })
                        }
                    </>
            }
            {/*<SinglePropertyContactForm />*/}
        </div>
    )
}
